import InternalStaticAnchorLearning from 'models/application/anchor/types/internalStatic/types/Learning';

export default class InternalStaticAnchorLearningService {
	toModel() {
		return new InternalStaticAnchorLearning();
	}
}
